/**
 * AI Summary Service
 * Handles conversation summary generation using OpenAI with structured prompts
 */

import { AxiosService } from '../../axios/axios.service.ts';
import {
  tSummaryRequest,
  tSummaryServiceResponse,
} from '../../types/summary.types';

export const summaryService = {
  generateSummary: async function(
    chatId: string,
    request: tSummaryRequest
  ): Promise<string> {
    try {
      const response = await AxiosService.post<tSummaryRequest, tSummaryServiceResponse>(
        `/ai/chats/${chatId}/summary`, request, {
        isLegacy: false,
      });

      return Promise.resolve(response.summary);
    } catch (error) {
      console.error('Error generating summary:', error);
      return Promise.reject(error);
    }
  }
}
